/*jshint esversion: 6 */

const initialState = () => ({

});

// State object
const state = initialState();
// Getter functions
const getters = {
  getSequencePreviewStatistics: (state, getters, rootState) => {
    let tstate = rootState.WorkBench;
    let statistics = {
      sequences: {},
      csequences: {},
      bsequences: {},
    };
    ['', 'c', 'b'].forEach(prefix => {
      Object.keys(tstate[`${prefix}sequences`]).forEach(sequence_id => {
        let waggon_ids = tstate[`${prefix}sequences`][sequence_id][`${prefix}swaggons`];
        let waggons = waggon_ids.map(waggon_id => tstate[`${prefix}swaggons`][waggon_id]);
        statistics[`${prefix}sequences`][sequence_id] = {
          steps: {
            percentage: 0,
            total: 0,
            segments: [
              {value: false, icon: 'takt_workstep', count: 0, steps: 0},
              {value: false, icon: 'takt_quality', count: 0, steps: 0},
              {value: false, icon: 'takt_defect', count: 0, steps: 0},
              {value: false, icon: 'takt_handover', count: 0, steps: 0},
              {value: false, icon: 'takt_logistic', count: 0, steps: 0},
              {value: false, icon: 'takt_design', count: 0, steps: 0},
            ]
          },
          images: {
            percentage: 0,
            total: 0,
            segments: [
              {value: false, icon: 'image', count: 0, images: 0},
            ]
          },
          values: {
            percentage: 0,
            total: 0,
            segments: [
              {value: false, icon: 'speed', values: 0},
              {value: false, icon: 'accessibility', values: 0},
              {value: false, icon: 'account_balance_wallet', values: 0},
              {value: false, icon: 'account_balance_wallet', values: 0},
              {value: false, icon: 'drag_indicator', values: 0},
              {value: false, icon: 'drag_indicator', values: 0},
            ]
          },
          waggons: [],
          wps_count: 0,
        };
        let sequence = statistics[`${prefix}sequences`][sequence_id];
        waggons.forEach(waggon => {
          let waggon_sum = {
            steps: {
              percentage: 0,
              total: 0,
              steps: 0,
            },
            images: {
              percentage: 0,
              total: 0,
              images: 0,
            },
            values: {
              percentage: 0,
              total: 0,
              values: 0,
            },
            wps_count: waggon[`${prefix}sworkpackages`].length,
            wps: [],
          };
          let workpackages = waggon[`${prefix}sworkpackages`].map(workpackage_id => tstate[`${prefix}sworkpackages`][workpackage_id]);
          workpackages.forEach(workpackage => {
            // steps
            let steps = 0;
            let steps_count = 0;
            let step_segments = [
              {value: false, icon: 'takt_workstep', count: 0},
              {value: false, icon: 'takt_quality', count: 0},
              {value: false, icon: 'takt_defect', count: 0},
              {value: false, icon: 'takt_handover', count: 0},
              {value: false, icon: 'takt_logistic', count: 0},
              {value: false, icon: 'takt_design', count: 0},
            ];
            ['work', 'quality', 'defect', 'handover', 'logistic', 'design'].forEach((type, index) => {
              if (workpackage[`${prefix}s${type}steps`]) {
                steps_count = steps_count + workpackage[`${prefix}s${type}steps`].length;
                if (workpackage[`${prefix}s${type}steps`].length !== 0) {
                  steps++;
                  waggon_sum.steps.steps++;
                  step_segments[index].value = true;
                  step_segments[index].count = workpackage[`${prefix}s${type}steps`].length;

                  sequence.steps.segments[index].steps++;
                  sequence.steps.segments[index].count = sequence.steps.segments[index].count + workpackage[`${prefix}s${type}steps`].length;
                }
              } else {
                steps_count = steps_count + workpackage[`${prefix}s${type}steps_count`];
                if (workpackage[`${prefix}s${type}steps_count`] !== 0) {
                  steps++;
                  waggon_sum.steps.steps++;
                  step_segments[index].value = true;
                  step_segments[index].count = workpackage[`${prefix}s${type}steps_count`];

                  sequence.steps.segments[index].steps++;
                  sequence.steps.segments[index].count = sequence.steps.segments[index].count + workpackage[`${prefix}s${type}steps_count`];
                }
              }
            });
            waggon_sum.steps.total = waggon_sum.steps.total + steps_count;
            sequence.steps.total = sequence.steps.total + steps_count;
            // images
            let images = 0;
            let images_count = 0;
            let image_segments = [
              {value: false, icon: 'image', count: 0},
            ];
            if (workpackage[`${prefix}sworkpackageimages`]) {
              images_count = workpackage[`${prefix}sworkpackageimages`].length;
              if (workpackage[`${prefix}sworkpackageimages`].length !== 0) {
                images = 1;
                waggon_sum.images.images++;
                image_segments[0].value = true;
                image_segments[0].count = workpackage[`${prefix}sworkpackageimages`].length;

                sequence.images.segments[0].images++;
                sequence.images.segments[0].count = sequence.images.segments[0].count + workpackage[`${prefix}sworkpackageimages`].length;
              }
            } else {
              images_count = workpackage[`${prefix}sworkpackageimages_count`];
              if (workpackage[`${prefix}sworkpackageimages_count`] !== 0) {
                images = 1;
                waggon_sum.images.images++;
                image_segments[0].value = true;
                image_segments[0].count = workpackage[`${prefix}sworkpackageimages_count`];

                sequence.images.segments[0].images++;
                sequence.images.segments[0].count = sequence.images.segments[0].count + workpackage[`${prefix}sworkpackageimages_count`];
              }
            }
            waggon_sum.images.total = waggon_sum.images.total + images_count;
            sequence.images.total = sequence.images.total + images_count;
            // values
            let values = 0;
            let value_segments = [
              {value: false, icon: 'speed'},
              {value: false, icon: 'accessibility'},
              {value: false, icon: 'account_balance_wallet'},
              {value: false, icon: 'account_balance_wallet'},
              {value: false, icon: 'drag_indicator'},
              {value: false, icon: 'drag_indicator'},
            ];
            [
              'time_effort_planned',
              'manpower_planned',
              'quantity_value',
              'costs_budget_labour',
              'costs_budget_material'
            ].forEach((type, index) => {
              if (parseInt(workpackage[type]) !== 0) {
                values++;
                waggon_sum.values.values++;
                value_segments[index].value = true;

                sequence.values.segments[index].values++;
              }
            });
            if (workpackage.quantity_unit !== '') {
              values++;
              waggon_sum.values.values++;
              value_segments[5].value = true;

              sequence.values.segments[5].values++;
            }
            waggon_sum.wps.push({
              color: workpackage.color,
              steps: {
                percentage: (steps / 6) * 100,
                total: steps_count,
                segments: step_segments,
              },
              images: {
                percentage: (images / 1) * 100,
                total: images_count,
                segments: image_segments,
              },
              values: {
                percentage: (values / 6) * 100,
                total: 0,
                segments: value_segments,
              },
            });
          });
          // write waggon_value
            waggon_sum.steps.percentage = (waggon_sum.steps.steps / (waggon_sum.wps_count * 6)) * 100;
            waggon_sum.images.percentage = (waggon_sum.images.images / (waggon_sum.wps_count * 1)) * 100;
            waggon_sum.values.percentage = (waggon_sum.values.values / (waggon_sum.wps_count * 6)) * 100;
            statistics[`${prefix}sequences`][sequence_id].waggons.push(waggon_sum);
            statistics[`${prefix}sequences`][sequence_id].wps_count = statistics[`${prefix}sequences`][sequence_id].wps_count + waggon_sum.wps_count;
        });
        ['steps', 'images', 'values'].forEach(type => {
          let count = 0;
          let max = 6;
          if (type === 'images') {
            max = 1;
          }
          sequence[type].segments.forEach(segment => {
            if (segment[type] === sequence.wps_count) {
              segment.value = true;
              count++;
            }
          });
          sequence[type].percentage = count / max * 100;
        });
      });
    });
    return statistics;
  },
  getSequencePreviewStatisticsOld: (state, getters, rootState) => {
    let tstate = rootState.WorkBench;
    let statistics = {
      sequences: {},
      csequences: {},
      bsequences: {},
      max_waggon_sum: {
        steps: 0,
        images: 0,
        values: 0,
      },
      max_sequence_sum: {
        steps: 0,
        images: 0,
        values: 0,
      }
    };
    ['', 'c', 'b'].forEach(prefix => {
      Object.keys(tstate[`${prefix}sequences`]).forEach(sequence_id => {
        let waggon_ids = tstate[`${prefix}sequences`][sequence_id][`${prefix}swaggons`];
        let waggons = waggon_ids.map(waggon_id => tstate[`${prefix}swaggons`][waggon_id]);
        statistics[`${prefix}sequences`][sequence_id] = {sequence_sum: {steps: 0, images: 0, values: 0}, waggons: []};
        waggons.forEach(waggon => {
          let waggon_sum = {
            steps: 0,
            images: 0,
            values: 0,
            wps_count: waggon[`${prefix}sworkpackages`].length,
          };
          let wps = [];
          getters.getSequenceWorkpackageColors({swaggons: waggon_ids, prefix: prefix}).forEach(color => {
            wps.push({
              steps: 0,
              images: 0,
              values: 0,
              color: color.value,
            });
          });
          let workpackages = waggon[`${prefix}sworkpackages`].map(workpackage_id => tstate[`${prefix}sworkpackages`][workpackage_id]);
          workpackages.forEach(workpackage => {
            // steps
            let steps = 0;
            ['work', 'quality', 'defect', 'handover', 'logistic', 'design'].forEach(type => {
              if (workpackage[`${prefix}s${type}steps`]) {
                steps = steps + workpackage[`${prefix}s${type}steps`].length;
              } else {
                steps = steps + workpackage[`${prefix}s${type}steps_count`];
              }
            });
            wps[wps.findIndex(wp => wp.color === workpackage.color)].steps += steps;
            waggon_sum.steps = waggon_sum.steps + steps;
            // images
            let images = 0;
            if (workpackage[`${prefix}sworkpackageimages`]) {
              images = workpackage[`${prefix}sworkpackageimages`].length;
            } else {
              images = workpackage[`${prefix}sworkpackageimages_count`];
            }
            wps[wps.findIndex(wp => wp.color === workpackage.color)].images += images;
            waggon_sum.images = waggon_sum.images + images;
            // values
            let values = 0;
            [
              'time_effort_planned',
              'manpower_planned',
              'quantity_value',
              'costs_budget_labour',
              'costs_budget_material'
            ].forEach(type => {
              if (parseInt(workpackage[type]) !== 0) {
                values++;
              }
            });
            if (workpackage.quantity_unit !== '') {
              values++;
            }
            wps[wps.findIndex(wp => wp.color === workpackage.color)].values += values;
            waggon_sum.values = waggon_sum.values + values;
          });
          //update max_waggon_sum
          if (waggon_sum.steps > statistics.max_waggon_sum.steps) {
            statistics.max_waggon_sum.steps = waggon_sum.steps;
          }
          if (waggon_sum.images > statistics.max_waggon_sum.images) {
            statistics.max_waggon_sum.images = waggon_sum.images;
          }
          if (waggon_sum.values > statistics.max_waggon_sum.values) {
            statistics.max_waggon_sum.values = waggon_sum.values;
          }
          // write waggon_value
            statistics[`${prefix}sequences`][sequence_id].waggons.push({
              waggon_sum: waggon_sum,
              wps: wps,
            });
            statistics[`${prefix}sequences`][sequence_id].sequence_sum.steps += waggon_sum.steps;
            statistics[`${prefix}sequences`][sequence_id].sequence_sum.images += waggon_sum.images;
            statistics[`${prefix}sequences`][sequence_id].sequence_sum.values += waggon_sum.values;
        });
        //update max_sequence_sum
        if (statistics[`${prefix}sequences`][sequence_id].sequence_sum.steps > statistics.max_sequence_sum.steps) {
          statistics.max_sequence_sum.steps = statistics[`${prefix}sequences`][sequence_id].sequence_sum.steps;
        }
        if (statistics[`${prefix}sequences`][sequence_id].sequence_sum.images > statistics.max_sequence_sum.images) {
          statistics.max_sequence_sum.images = statistics[`${prefix}sequences`][sequence_id].sequence_sum.images;
        }
        if (statistics[`${prefix}sequences`][sequence_id].sequence_sum.values > statistics.max_sequence_sum.values) {
          statistics.max_sequence_sum.values = statistics[`${prefix}sequences`][sequence_id].sequence_sum.values;
        }
      });
    });
    return statistics;
  }
};

// Actions
const actions = {
};

// Mutations
const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
